(function($) {
    'use strict';

    let $body = $(document.body);

    $body.on('click', '.main-menu > .menu-item-has-children > .sub-menu-toggle', function(e) {

        if ( $(this).parent().hasClass('active') ) {

            $('.sub-menu-toggle').parent().removeClass('active');
            $('.sub-menu-toggle').parent().siblings().removeClass('inactive');
            $('.top-menu').removeClass('inactive');
            $('.menu-overlay').removeClass('active');

        } else {

            $('.sub-menu-toggle').parent().removeClass('active');
            $('.sub-menu-toggle').parent().siblings().removeClass('inactive');

            $(this).parent().addClass('active');
            $(this).parent().siblings().addClass('inactive');
            $('.top-menu').addClass('inactive');
            $('.menu-overlay').addClass('active');

        }

    });

    $body.on('click', '.flyout-menu', function(e) {
        if (e.target !== this) {
            return;
        }

        $body.trigger('flyout/hide');

    });

    $body.on('click', '.menu-overlay', function(e) {
        if (e.target !== this) {
            return;
        }

        $body.trigger('flyout/hide');

    });


    if ( ! $('html').hasClass('menu-open') ) {

        $body.on('click', '.menu-toggle', function() {

            $('.lang-toggle').parent().removeClass('active');

            $('.flyout-menu').addClass('active');
            $('body').attr( 'data-pos', $(window).scrollTop() );
            $('html').addClass('menu-open');

        });

    }

    class Flyout {
        constructor() {
            $body.on(
                'click',
                '.menu-close',
                this.flyout_hide,
            );
            $(document).on('flyout/hide', this.flyout_hide);
        }

        flyout_hide = () => {
            var scrolltop = $('body').attr( 'data-pos');
            $(window).scrollTop(scrolltop)
            $('.flyout-menu .flyout-content').addClass('closed');

            setTimeout(function() {
                $('.flyout-menu').removeClass('active');
                $('.flyout-menu .flyout-content').removeClass('closed');
                $('.sub-menu-toggle').parent().removeClass('active');
                $('.sub-menu-toggle').parent().siblings().removeClass('inactive');
                $('.top-menu').removeClass('inactive');
                $('.menu-overlay').removeClass('active');
                $('html').removeClass('menu-open');
            }, 100);
        };
    }

    new Flyout();

}(jQuery));
